export const BASE_PATH = 'signup2023';

export const SIGNUP_ID_COOKIE_NAME = 'juni_signup_id';
